module.exports = __webpack_public_path__ + "img/2.85f1255a.jpg";